import { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useForm } from 'react-hook-form';
import queryString from 'query-string';

import {
  FormGroup,
  FormLabel,
  Grid,
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CustomTextField, CustomButton } from 'components/common';

import { ApiPostNoAuth } from 'helpers/Api/ApiData';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import signinImg from 'assets/images/signin-img.svg';

import Auth from 'helpers/auth';

import Link from 'components/Link';
import { useRouter } from 'next/router';
import { useUser } from 'context/user.context';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

interface GmailSignupProps {
  // loader: boolean;
  handleBack: () => void;
  googleLoginResponse: any;
}

const GmailSignup = ({ handleBack, googleLoginResponse }: GmailSignupProps) => {
  const history = useRouter();
  const theme = useTheme();
  const useStyles = makeStyles({
    loginSignUpWrap: {
      // minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      '& MuiGrid-item': {
        width: '100%',
      },
      // [theme.breakpoints.down('sm')]:{
      //     minHeight: "calc(100vh - 256px)",
      // }
    },
    loginSignUpBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '30px 30px',
      display: 'flex',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      // [theme.breakpoints.down('lg')]: {
      //     padding: "0px 15% 50px",
      // },
      // [theme.breakpoints.down('sm')]: {
      //     padding: "50px 15% 50px",
      // },

      // [theme.breakpoints.down('xs')]: {
      //     padding: "50px 10% 50px",
      // },

      '& h2': {
        marginBottom: 20,
        fontWeight: 500,
        fontSize: 20,
        lineHeight: 1,
        color: '#111111',
      },

      '& .MuiFormGroup-root': {
        marginBottom: 20,
      },

      '& .MuiFormLabel-root': {
        fontSize: 14,
        color: '#111111',
        lineHeight: 1.2,
        padding: 0,
      },
      '& .MuiInputLabel-outlined': {
        transform: 'translate(15px, 12px) scale(1)',
        [theme.breakpoints.down('xs')]: {
          transform: 'translate(15px, 15px) scale(1)',
        },
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(15px, -8px) scale(1)',
        backgroundColor: '#fff',
        fontSize: 12,
        padding: '0 11px',
        color: 'rgba(17, 17, 17, 0.5)',
      },
      '& .MuiInputBase-formControl': {
        '& .MuiOutlinedInput-input': {
          padding: '12px 15px',
          fontSize: 14,
          [theme.breakpoints.down('xs')]: {
            fontSize: 14,
            padding: '15px 15px',
          },
        },
      },
      '& .MuiButton-root': {
        width: '250px',
        borderRadius: 40,
        margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
        },
      },
    },
    loginSignImg: {
      height: 'calc(100%)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '90px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    loginSignImg1: {
      height: 'calc(100vh)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '175px',

      '& img': {
        width: '60%',
        display: 'noone',
        margin: '0 auto 100px',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },

    loginSignImg2: {
      paddingTop: '100px',
      '& img': {
        width: '50%',
        display: 'none',
        margin: '0 auto 50px',
        [theme.breakpoints.down('md')]: {
          display: 'none',
        },
      },
    },
    forgotLink: {
      cursor: 'pointer',
      display: 'block',
      fontSize: 14,
      color: 'rgba(17, 17, 17, 0.7)',
      lineHeight: '19px',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '&:hover': {
        color: 'rgba(17, 17, 17, 1)',
      },
    },
    newRegister: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111',
      fontWeight: 400,
      marginTop: -10,
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },
    error: {
      fontSize: 12,
      lineHeight: 1,
      display: 'flex',
      // flexWrap: 'wrap',
      marginTop: 5,

      '& svg': {
        fontSize: 14,
        verticalAlign: 'middle',
        marginRight: 4,
      },
      '& .MuiInputBase-formControl': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#DD6161',
        },
      },
    },
    radioWant: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,
      alignItems: 'center',

      '& .MuiFormLabel-root': {
        width: 100,
      },

      '& .MuiFormGroup-row': {
        marginBottom: 0,
        width: 'calc(100% - 100px)',
        [theme.breakpoints.down('sm')]: {
          width: 'calc(100% - 30px)',
        },
      },

      '& .MuiFormControlLabel-root': {
        marginRight: 40,
        [theme.breakpoints.down('xs')]: {
          marginRight: 30,
        },
      },

      '& .MuiFormControlLabel-label': {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 16,
        },
      },

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    SignUpWelcome: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '45px 25% 0',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',

      [theme.breakpoints.down('sm')]: {
        padding: '0px 15% 0',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '0 10%',
      },
    },
    SignUpWelcomeContent: {
      display: 'flex',
      flexWrap: 'wrap',

      '& h2': {
        width: '100%',
        display: 'block',
        fontWeight: 500,
        fontSize: 28,
        lineHeight: 1,
        color: '#111111',
        textAlign: 'center',
        margin: '54px 0 18px 0',
        [theme.breakpoints.down('xs')]: {
          marginTop: '50px',
        },
      },
      '& p': {
        display: 'block',
        fontWeight: 400,
        fontSize: 20,
        lineHeight: '28px',
        color: '#111111',
        textAlign: 'center',
      },
      '& span': {
        fontSize: '12px',
        textAlign: 'center',
        marginTop: '20px',
        lineHeight: '16px',
        padding: '10px 20px',
        color: 'rgba(17, 17, 17,0.5)',
      },
    },
    loginSignUpForm: {
      display: 'flex',
      width: '100%',
      maxWidth: 524,
      margin: '0 auto',
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      '& form': {
        width: '100%',
        display: 'block',
      },
    },

    ReferralCode: {
      '& .MuiInputBase-root': {
        '& input': {
          textTransform: 'uppercase',
          '&:disabled': {
            color: 'rgba(17, 17, 17,0.5)',
          },
        },
      },
    },
    passwordIcon: {
      verticalAlign: 'middle',
      marginRight: 4,
      '& svg': {
        fontSize: '1.5rem',
      },
    },
    firstNameTExtField: {
      '& .MuiFormControl-root': {
        marginBottom: '0px',
      },
      '& MuiBox-root': {
        marginTop: '0px',
      },
      [theme.breakpoints.down('xs')]: {
        marginBottom: '-4px !important',
      },
    },

    //Gmail Account
    gmailAccountWrap: {
      // minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      '& MuiGrid-item': {
        width: '100%',
      },
    },
    gmailSignImg: {
      height: 'calc(100%)',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(252, 252, 252, 0.5)',
      paddingTop: '90px',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    signUpGmailBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '49px 30px',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      display: 'flex',
      alignItems: 'flex-start',
      //flexDirection: "column",
      [theme.breakpoints.down(767)]: {
        padding: '49px 15px',
        flexDirection: 'column',
      },
      '& .MuiSvgIcon-root': {
        cursor: 'pointer',
      },
      backIcon: {
        marginRight: '10px',
      },
      '& h2': {
        marginBottom: 20,
        fontWeight: 500,
        fontSize: 20,
        lineHeight: 1,
        color: '#111111',
      },
      '& .MuiButton-root': {
        width: '250px',
        borderRadius: 40,
        margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
        },
      },
    },
    '& .MuiFormGroup-root': {
      marginBottom: 20,
    },

    '& .MuiFormLabel-root': {
      fontSize: 14,
      color: '#111111',
      lineHeight: 1.2,
      padding: 0,
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(15px, 12px) scale(1)',
      [theme.breakpoints.down('xs')]: {
        transform: 'translate(15px, 15px) scale(1)',
      },
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(15px, -8px) scale(1)',
      backgroundColor: '#fff',
      fontSize: 12,
      padding: '0 11px',
      color: 'rgba(17, 17, 17, 0.5)',
    },
    '& .MuiInputBase-formControl': {
      '& .MuiOutlinedInput-input': {
        padding: '12px 15px',
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
          padding: '15px 15px',
        },
      },
    },
    signUpGmailForm: {
      display: 'block',
      width: '100%',
      maxWidth: 524,
      margin: '0 auto',
      heading: {
        display: 'flex',
      },
    },
    gmailRadioWant: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,
      alignItems: 'center',

      '& .MuiFormLabel-root': {
        color: '#111111',
        width: 100,
        fontSize: 14,
      },

      '& .MuiFormGroup-row': {
        marginBottom: 0,
        [theme.breakpoints.down(767)]: {
          width: '100%',
        },
      },

      '& .MuiFormControlLabel-root': {
        marginRight: 40,
        [theme.breakpoints.down('xs')]: {
          marginRight: 30,
        },
      },

      '& .MuiFormControlLabel-label': {
        fontSize: 14,
        [theme.breakpoints.down('xs')]: {
          fontSize: 14,
        },
      },

      [theme.breakpoints.down(767)]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    mobileTextField: {
      marginBottom: '25px',
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 16px) scale(1)',
        fontSize: '14px',
      },
      '& .MuiInputBase-input': {
        padding: '12px 15px',
        fontSize: '14px',
      },
    },
    referrerTextField: {
      marginBottom: '51px',
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 16px) scale(1)',
        fontSize: '14px',
      },
      '& .MuiInputBase-input': {
        padding: '12px 15px',
        fontSize: '14px',
      },
    },
    gmailSignupButton: {
      alignItems: 'center',
      marginBottom: '27px',
      '& span': {
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 'bold',
      },
    },
    gmailNewRegister: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111111',
      fontWeight: 400,
      //	marginTop: '40px',
      //	marginLeft: '35px',
      fontStyle: 'normal',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },

    //Two Button Account
    signUpAccountWrap: {
      //minHeight: "calc(100vh - 90px)",
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      '& MuiGrid-item': {
        width: '100%',
      },
    },
    signUpAccountBox: {
      height: '100%',
      backgroundColor: '#fff',
      padding: '30px',
      // padding: "0px 22% 50px",
      borderRadius: 0,
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      justifyContent: 'center',
      textAlign: 'center',
      '& h2': {
        margin: '0 auto 20px',
        fontWeight: 500,
        fontSize: 28,
        lineHeight: 1,
        color: '#111111',
        [theme.breakpoints.down(767)]: {
          fontSize: '22px !important',
        },
      },
      '& .MuiButton-root': {
        // maxWidth: "280px",
        width: '100%',
        borderRadius: 40,
        // margin: '0px auto',

        '& span': {
          fontSize: 20,
          lineHeight: 1,
          [theme.breakpoints.down(360)]: {
            fontSize: 18,
          },
        },
      },
    },
    signUpAccountForm: {
      width: '100%',
      // maxWidth: 531,
      margin: '0 auto',
      '& h2': {
        fontSize: 24,
        fontStyle: 'normal',
        fontWeight: 500,
        textAlign: 'center',
        color: '#111111',
      },
    },
    signupAccountButton: {
      margin: '0px auto 0',

      '& button:first-child': {
        marginBottom: '17px',
        maxWidth: '250px',
        border: '1px solid transparent',
        '& span': {
          justifyContent: 'flex-start',
        },
      },
      '& button:last-child': {
        // minHeight: "64px",
        maxWidth: '250px',
        marginBottom: '32px',
      },
      '& small': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: '#fff',
        width: '40px',
        height: '40px',
        marginRight: '8px',
        padding: '5px',
      },
    },

    newRegisterAccount: {
      textAlign: 'center',
      fontSize: 14,
      color: '#111',
      fontWeight: 400,
      margin: '0 auto',
      fontStyle: 'normal',
      [theme.breakpoints.down('xs')]: {
        fontSize: 16,
      },
      '& a': {
        color: '#008b5e',
        fontWeight: 700,
      },
    },
  });
  const classes = useStyles();
  const queryReferralCode = history.query.referral_code as string | undefined;
  const [role_id, setRole_id] = useState<'1' | '2'>('1');
  const [loader, setLoader] = useState(false);
  // const [googleLoginResponse, setGoogleLoginResponse] = useState<any>();
  const [isReady, setIsReady] = useState<boolean>(false);

  const [, , setUser] = useUser();

  interface FormFields {
    first_name: string;
    last_name: string;
    email: string;
    phone_no: string;
    referrer_code: string;
    role_id: '1' | '2';
    password: string;
    confirm_password: string;
    age: number;
  }

  const schema = yup.object().shape({
    phone_no: yup
      .string()
      .matches(/^[0-9]{10}$/, 'Invalid Mobile Number')
      .required('Phone number is required'),
    referrer_code: yup
      .string()
      .notRequired()
      .matches(/^(POD|pod)[a-zA-Z0-9]{7}\s*$/, {
        message: 'Invalid referral code',
        excludeEmptyString: true,
      }),
  });

  const { control, handleSubmit } = useForm<FormFields>({
    resolver: yupResolver(schema),
    mode: 'onTouched',
    defaultValues: {
      referrer_code: queryReferralCode,
    },
  });

  const onSubmitGoogleRegister = async (data: any) => {
    try {
      setLoader(true);
      delete googleLoginResponse?.googleId;
      const res: any = await ApiPostNoAuth(`user/socialLogin`, {
        ...googleLoginResponse,
        role_id,
        ...data,
        referrer_code: data?.referrer_code?.toUpperCase().trim(),
        type: 'signup',
      });
      if (res.data.data !== null && res.data.statusCode === 200) {
        setLoader(false);
        const data = res.data.data;
        Auth.setAuthToken(data.token);
        if (data.user.role_id === 1) {
          // console.log(res.data?.data?.user);
          // debugger;
          // Auth.setUserData(res.data?.data?.user);
          setUser({ user: res.data?.data?.user, isLoading: false });
          // const redirect_url = new URLSearchParams(history.location.search).get(
          //   'redirect_url',
          // );
          // if (redirect_url) {
          //   window.location.replace(`${decodeURIComponent(redirect_url)}`);
          // } else {
          history.push('/startups');
          // }
          // isRedirectUrl(history, data.user.role_id, data.user.status, data.user.company);
          // history.push('/investor-assessment')
          // toast.success(res.data.message, { autoClose: 5000, hideProgressBar: true });
        } else if (data.user.role_id === 2) {
          // Auth.setUserData(res.data?.data?.user);
          // setUser(res.data?.data?.user);
          setUser({ user: res.data?.data?.user, isLoading: false });

          history.push('/create-startup-profile');
          // toast.success(res.data.message, { autoClose: 5000, hideProgressBar: true });
        } else {
          toast.success('Admin cannot login', {
            autoClose: 5000,
            hideProgressBar: true,
          });
        }
      } else {
        toast.error(res.data.message, {
          autoClose: 5000,
          hideProgressBar: true,
        });
        setLoader(false);
      }
    } catch (error: any) {
      console.log(error);
      toast.error(error.message, { autoClose: 5000, hideProgressBar: true });
      setLoader(false);
    }
  };

  useEffect(() => {
    const queryStringValue = window.location.search;
    const queryObject = queryString.parse(queryStringValue);
    if (queryObject?.userType == '2') {
      setRole_id('2');
    }
    setIsReady(true);
  }, []);

  if (!isReady) {
    return null;
  }

  return (
    <div className={classes.gmailAccountWrap}>
      <ToastContainer />
      <Grid container>
        <Grid item xs={12} sm={12} md={6}>
          <div className={classes.gmailSignImg}>
            <img src={signinImg.src} alt="signInImage" />
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div className={classes.signUpGmailBox}>
            <div className="backIcon">
              <ArrowBackIcon onClick={() => handleBack()} />
            </div>
            <div className={classes.signUpGmailForm}>
              {/* <div className={classes.heading}> */}
              {/* </div> */}

              <form onSubmit={handleSubmit(onSubmitGoogleRegister)}>
                <h2> Sign up to create an account </h2>
                <FormControl component="div" className={classes.gmailRadioWant}>
                  <FormLabel component="legend">I want to</FormLabel>
                  <RadioGroup
                    row
                    name="role_id"
                    defaultValue={role_id}
                    value={role_id}
                    onChange={(e) => setRole_id(e.target.value as '1' | '2')}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio color="primary" />}
                      label="Invest"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio color="primary" />}
                      label="Raise Funds"
                    />
                  </RadioGroup>
                </FormControl>
                <FormGroup
                // component="div"
                // className={classes.mobileTextField}
                >
                  <CustomTextField
                    control={control}
                    variant="outlined"
                    name="phone_no"
                    margin="dense"
                    fullWidth
                    inputProps={{ maxLength: 10 }}
                    label="Mobile Number"
                  />
                  {/* <Controller
									name="phone_no"
									control={control}
									defaultValue={''}
									rules={{
										required: 'Mobile Number is required',
										pattern: {
											value: /^[0-9]{10}$/,
											message: 'Invalid Mobile Number',
										},
									}}
									render={({ value, onChange, onBlur }) => {
										return (
											<CustomTextField
												fullWidth
												onBlur={(e) => onBlur(e)}
												name="phone_no"
												value={value}
												type="text"
												variant="outlined"
												label="Mobile Number"
												autoComplete="false"
												onChange={(e) => {
													validatePhone(e, onChange);
												}}
												className={
													errors.phone_no && classes.error
												}
											/>
										);
									}}
								/>
								{errors.phone_no && (
									<Box
										className={classes.error}
										color="error.main"
									>
										<InfoOutlined />
										{errors.phone_no.message}
									</Box>
								)} */}
                </FormGroup>

                {role_id === '1' ? (
                  <FormGroup
                  // component="div"
                  // className={classes.referrerTextField}
                  >
                    <CustomTextField
                      control={control}
                      variant="outlined"
                      name="referrer_code"
                      fullWidth
                      label="Referral code (optional)"
                    />
                    {/* <CustomTextField
                      // defaultValue={referral}
                      fullWidth
                      name="referrer_code"
                      type="text"
                      label="Referral code (optional)"
                      variant="outlined"
                      autoComplete="false"
                      // disabled={referral ? true : false}
                      disabled={true}
                      rules={{
                        pattern: {
                          value: /^(POD|pod)[a-zA-Z0-9]{7}\s*$/,
                          message: 'Invalid referral code',
                        },
                      }}
                      control={control}
                      className={classes.ReferralCode}
                    /> */}

                    {/* {errors.referrer_code && (
                      <Box className={classes.error} color="error.main">
                        <InfoOutlined />
                        {errors.referrer_code.message}
                      </Box>
                    )} */}
                  </FormGroup>
                ) : null}
                <FormGroup
                  // component="div"
                  className={classes.gmailSignupButton}
                >
                  {/* {loader ? (
                    <CustomButton
                    // bgColor="#008b5e"
                    // bordercolor="#008b5e"
                    // fontColor="#ffffff"
                    // radius="0"
                    // btnPadding="15"
                    >
                      <CircularProgress color="inherit" size={16} />
                    </CustomButton>
                  ) : ( */}
                  <CustomButton
                    type="submit"
                    variant="contained"
                    sx={{
                      fontSize: 16,
                      height: 40,
                      width: {
                        xs: '100%',
                        md: 180,
                      },
                      display: 'block',
                      margin: 'auto',
                    }}
                  >
                    {loader ? (
                      <CircularProgress color="inherit" size={14} />
                    ) : (
                      'Proceed'
                    )}
                  </CustomButton>
                  {/* )} */}
                </FormGroup>
                <div className={classes.gmailNewRegister}>
                  Already have an account?{' '}
                  <Link
                    // to={
                    //   redirectUrl
                    //     ? {
                    //         pathname: '/login',
                    //         search: `?redirect_url=${encodeURIComponent(
                    //           redirectUrl,
                    //         )}`,
                    //       }
                    //     : { pathname: '/login' }
                    // }
                    href="/login"
                  >
                    Login
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default GmailSignup;
